import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useTitle } from "@/lib/img";

export default function AdminLogin() {
  useTitle("Studio Admin | Medium Plenty");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("mp_token", data.token);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-paper flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <p className="font-serif text-2xl tracking-tight mb-1">Medium Plenty</p>
        <p className="text-[10px] uppercase tracking-[0.3em] text-smoke mb-10">Studio Admin</p>
        <form onSubmit={submit} className="space-y-7">
          <div>
            <label htmlFor="admin-email" className="field-label">Email</label>
            <input
              id="admin-email"
              data-testid="admin-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="field-input"
              autoComplete="username"
            />
          </div>
          <div>
            <label htmlFor="admin-password" className="field-label">Password</label>
            <input
              id="admin-password"
              data-testid="admin-password-input"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="field-input"
              autoComplete="current-password"
            />
          </div>
          {error && (
            <p data-testid="admin-login-error" className="text-sm text-red-800">{error}</p>
          )}
          <button
            data-testid="admin-login-button"
            type="submit"
            disabled={loading}
            className="w-full border border-ink py-3.5 text-sm tracking-[0.1em] uppercase hover:bg-ink hover:text-paper transition-colors duration-300 disabled:opacity-50"
          >
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
